// extracted by mini-css-extract-plugin
export default {"textSlot":"DropdownMenu_textSlot__23-Sq","items":"DropdownMenu_items__X0lOq","divider":"DropdownMenu_divider__r7Cqf"};